import { BrowserRouter, Route, Routes, Navigate } from 'react-router';
import Layout from './components/Layout';
import RequestsPage from './pages/RequestsPage';

const App = () => {
	return (
		<BrowserRouter basename={import.meta.env.BASE_URL}>
			<Routes>
				<Route element={<Layout />}>
					<Route index element={<Navigate to="/requests" replace />} />
					<Route path="/requests" element={<RequestsPage />} />
				</Route>
			</Routes>
		</BrowserRouter>
	);
};

export default App;
